import cx from 'classnames';
import React, { useContext } from 'react';
import {
  LockedBadge,
  OnHoldBadge,
  PreOrderBadge,
  RecentlyAddedBadge,
  TimerBadge
} from '@/vdp/Badges';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import { useGetIsRecentlyAdded } from '~/context/vdp/VehicleContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsReservableVehicle from '~/hooks/vdp/selectors/useIsReservableVehicle';
import useIsInSoftNotifyExperiment from '~/hooks/vdp/useInSoftNotifyExperiment';

type OwnProps = Omit<React.HTMLProps<HTMLDivElement>, 'ref'> & {
  showTimer?: boolean;
};

export default function HeroBadge({ showTimer, ...props }: OwnProps) {
  const { isInitialized, shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useAlertStatus();
  const isReservable = useIsReservableVehicle();
  const isRecentlyAdded = useGetIsRecentlyAdded();
  const isInSoftNotifyExperiment = useIsInSoftNotifyExperiment();

  switch (true) {
    case !isInitialized:
      return null;
    case purchasePending && shouldShowTimer:
      return showTimer ? (
        <div className="flex">
          <OnHoldBadge
            {...props}
            className={cx(props.className, 'rounded-r-none')}
          />
          <TimerBadge
            {...props}
            className={cx(props.className, 'rounded-l-none')}
          />
        </div>
      ) : (
        <OnHoldBadge {...props} />
      );
    case purchasePending:
      return <LockedBadge {...props} />;
    case isReservable:
      return <PreOrderBadge {...props} />;
    case isRecentlyAdded && !isInSoftNotifyExperiment:
      return <RecentlyAddedBadge {...props} />;
    default:
      return null;
  }
}
